




import React from 'react';

import ReactDOM from 'react-dom';


import { Menu, Button } from '@jd/find-react';
import KeeVue from '../base/KeeVue.js'

import $ from 'jquery';
const { SubMenu } = Menu;








export default class FsMainMenu extends KeeVue {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
	  defaultOpenKeys:[],
      selectedKeys: [],
      menus: [], 
    }

  }

  componentWillMount() {
    this.registComponent();
    
	this.initData();
    let that = this;
	 
	 
	if(!window.popstateHandle)
	{
		window.popstateHandle = function(state, title, url){
			 
			that.sendEvent("onpopstate");
		}
	}
	
	// 多个菜单的时候，需要处理一下
	if(!window.onpopstate)
	{
		window.onpopstate = window.popstateHandle;
		 
		//  function (state, title, url) {
		// 	//alert("frame onpopstate:"+JSON.stringify(state));
		//   that.onHashChange();
		// }
	}
	
	  
	
	
	this.onEvent("onpopstate",()=>{
		//debugger;
		that.onHashChange();
	})
    
	
	this.onEvent("HashChange",(url,params)=>{
		// 
		 
		//alert("mainMenu的hashchange收到事件"+url);
		this.openHashSp(url,params);
		this.$emit("HashChange",url,params);
		
	});
	
	if(!this.props.mode)
	{
		this.onEvent("selectTopMenuItem",(menuItem)=>{
			
			setTimeout(()=>{
				 this.state.menus = menuItem.children;
				 
				 this.topMenuItem = menuItem;
				 
				 if(menuItem.children&&menuItem.children.length>1){
				 	
				 	$("#jz-left-body").show();
				 	
				 	$("#feasApp").removeClass("openTopMenuFullPage");
					 
				 }
				 else
				 {
				 	$("#jz-left-body").hide();
					$("#feasApp").show();
				  
					$("#feasApp").addClass("openTopMenuFullPage");
				 }
				 
				 // // 然后选择第一个菜单节点？？
				 // if(menuItem.children&&menuItem.children.length>0)
				 // {
				 // 	this.openMenuPage(this.state.menus[0]);
				 // }
				  
				 
				 //if(this.state.menus&&this.state.menus.length>0)
				 {
				 	this.onHashChange();
				 }
				 this.refresh();
			},100);
			
			
			
			
		})
	}
	
	
	
	
  }

 
  initData = () => {
	   
	if(!this.props.mode&&window.clientMap.useTopMenu)
	{
		return ;
	}
	 
	if(window.mainInfo&&window.mainInfo.success&&window.mainInfo.retData.menus)
	{
		let ret = JSON.parse(window.mainInfo.retData.menus);
		
		  if (ret && ret.menus&&ret.menus.length>0) {
			  
			  // 处理 icon，二级及以下菜单不要图标
			 ret.menus.map((item,index)=>{
				 if(item.children)
				 {
					 item.children.map((item2)=>{
						 if(!window.clientMap.useTopMenu)
						 {
							item2.icon=""; 
						 }
						 
						 if(item2.children)
						 {
						 	item2.children.map((item3)=>{
						 	item3.icon="";
						 	 
						    })
						 }
					 })
				 }
			 });
			  
		    this.state.menus = ret.menus;
			this.state.topMenus = ret.menus;
		 
			this.onHashChange();
		    this.refresh();
		  } 
		  else
		  {
			  $("#root").hide()
			  $("#errorInfoDiv").show();
			  $("#errorInfoDiv").html("您的账号未关联任何菜单，请联系管理员！")
			 
		  }
	}
	else
	{
		this.doRequest("/mainFrame/getMenus", (ret) => {
		  if (ret && ret.menus&&ret.menus.length>0) {
			  
			  // 处理 icon，二级及以下菜单不要图标
			 ret.menus.map((item,index)=>{
				 if(item.children)
				 {
					 item.children.map((item2)=>{
						 item2.icon="";
						 if(item2.children)
						 {
						 				 item2.children.map((item3)=>{
						 					 item3.icon="";
						 					 
						 				 })
						 }
					 })
				 }
			 });
			  
		    this.state.menus = ret.menus;
			 
			this.state.topMenus = ret.menus;
			this.onHashChange();
		    this.refresh();
		  }
		  else
		  { 
			 $("#root").hide()
			 $("#errorInfoDiv").show();
			 $("#errorInfoDiv").html("您的账号未关联任何菜单，请联系管理员！")
			 			 
			   
		  }
		
		
		
		})
	}



 

  }
  initTreeStateData = (data, roleIds) => { }
	findUrlFromNodes=(nodes, path)=> {
				if(nodes != null) {
					console.log()
					for(let i = 0; i < nodes.length; i++) {

						// 判断提交 
						//if(nodes[i].path == path) 
						if(path.indexOf(nodes[i].id+"_")==0) 
						{
							// 是这个节点

							// this.selectMenu(this.menuNodes, nodes[i]);

							// this.updateMenuState(nodes[i]);
							
							this.state.selectedKeys.push(nodes[i].id);
							
						
							
							return nodes[i];
							
						} else {

							if(nodes[i].children != null) {
								
								let src = this.findUrlFromNodes(nodes[i].children, path);
								if(src != null) {
									this.state.defaultOpenKeys.push(nodes[i].id);
									return src;
								}
							}
						}
					}
				}

			} 
			
			
  openMenuPage=(menuItem)=>{
	  let  src = menuItem.attributes.src;
	  //需要隔离菜单对象，否则会导致误修改
	  this.$emit("HashChange",src, JSON.parse(JSON.stringify(menuItem)) );
  } 
  onHashChange = () => {

    let that = this;

    let hash = "";
    // hash 为 #xxx 格式

    hash = window.location.hash;
    hash = hash.replace('#', '');


    if (window.history.state && window.history.state.sp) {
      hash = window.history.state.sp;
    }
	
	if(this.getQueryVariable("sp"))
	{
		hash = this.getQueryVariable("sp");
	}

	this.state.selectedKeys = [];
	this.state.defaultOpenKeys=[];

    that.currentHash = hash;

    console.log("检测到hash值变更：：：：：" + hash+" "+this.props.mode);
	
	let targMenus = that.state.topMenus;
	
	if(!targMenus)
	{
		targMenus = that.state.menus;
	}
	 
    let node = that.findUrlFromNodes(targMenus, hash);
	
	if(!node&&this.topMenuItem)
	{
		//看是不是根节点		
		node = that.findUrlFromNodes([this.topMenuItem], hash);
	}
	
	//return nodes[i].attributes.src;
	let src = null;
	
	//debugger;
	if(node)
	{
	
		if(!window.topCurrentMenuPage)
		{
			window.topCurrentMenuPage = {};
			
			
		}
		if(this.topMenuItem)
		{
			window.topCurrentMenuPage[this.topMenuItem.id] = node;
		}
		
		
		let path =  hash.replace(node.id+"_","");
		
		if(path.indexOf("!routerjson")!=-1)
		{	
			 path = path.substring(0,path.indexOf("!routerjson"));
		}
		src = path;
	}
	else
	{
		let hasPermissionMenu = that.findUrlFromNodes(that.state.topMenus, hash);
		
		if(hash&&!hasPermissionMenu && that.state.topMenus)
		{
			console.log("无访问权限:"+hash);
			 alert("无访问权限");
			
			// 重定向到首页
			
			 //window.location.href=window.rootWebPath;
			
			 return ;
		}
		
		// 如果是表单页面，可以直接展示，由表单控制渲染逻辑
		 
		src=hash;
	}
	
	
	// 如果找不到这个菜单，则跳转到默认的第一个菜单；如果是表单页面或者是应用管理页面，则直接显示，应用页面需要判断权限
	

    console.log("找到src：" + src + "   path：" + hash)

    if (src != null && (src.indexOf("/secondFrame") == 0 || src.indexOf("/thirdFrame") == 0)) {
      src = "";
    }

    if (!src&&(hash&&hash.indexOf("/")==-1)) {
	  this.state.selectedKeys.push(that.state.menus[0].id);
      src = that.state.menus[0].attributes.src;
	  node = that.state.menus[0];
      //that.updateMenuState(ret.menus[0]);
	  
	  this.state.menus = node.children;
	  
	  this.topMenuItem = node;
	  
	  if(window.clientMap.useTopMenu)
	  {
		 if(node.children&&node.children.length>1){
		 	
		 	$("#jz-left-body").show();
		 	
		 	$("#feasApp").removeClass("openTopMenuFullPage");
		 					 
		 }
		 else
		 {
		 	$("#jz-left-body").hide();
		  
		 					$("#feasApp").addClass("openTopMenuFullPage");
		 } 
	  }
	  
	  
    }
	
	if(this.props.mode&&node)
	{
		// 然后选择第一个菜单节点？？
		for(let i=0;this.state.topMenus&&i<that.state.topMenus.length;i++)
		{
			if(node.attributes.treePath.indexOf(that.state.topMenus[i].attributes.treePath)==0)
			{
			 
				
				
				setTimeout(()=>{
					this.state.selectedKeys = [];
					this.state.selectedKeys.push(that.state.topMenus[i].id);
					
					console.log("menu：：：selectTopMenuItem event"+that.state.topMenus[i]);
					this.sendEvent("selectTopMenuItem",that.state.menus[i]);
				},100);
				//	this.sendEvent("selectTopMenuItem",that.state.topMenus[i]);
				
				
			}
		}
		 
		
		return ;
		
		
	}
	
	if((!hash&&!src)||!node)
	{
		
		let appCode = this.getUrlParameter("appCode");
		
		
	
		if((appCode&&appCode.indexOf("REPORT_")!=-1)||hash.indexOf("M::REPORT")!=-1||hash.indexOf("M::jzbForm")!=-1||(hash.indexOf("M::jdccApp/")!=-1&&window.hasPermission("ADMIN")))
		{ 
			
		} 
		else
		{
			if(that.state.topMenus&&that.state.topMenus.length>0)
			{
				if(this.props.mode&&node)
				{
					// setTimeout(()=>{
					// 	this.sendEvent("selectTopMenuItem",that.state.menus[0]);
					// },100);
					this.sendEvent("selectTopMenuItem",that.state.topMenus[0]);
				}
				
				 
				if(that.state.topMenus[0].children&&that.state.topMenus[0].children.length>0)
				{
					this.state.selectedKeys.push(that.state.topMenus[0].children[0].id);
					src = that.state.topMenus[0].children[0].attributes.src;
					node = that.state.topMenus[0].children[0];
					this.state.selectedKeys = [];
					this.state.selectedKeys.push(that.state.topMenus[0].id);
					
					this.state.defaultOpenKeys.push(that.state.topMenus[0]);
				 
					this.findUrlFromNodes(this.state.topMenus,node.path);
				 
					if(this.props.mode)
					{
						this.sendEvent("selectTopMenuItem",that.state.topMenus[0]);
					}
					
					 
				}
				else
				{
					this.state.selectedKeys.push(that.state.topMenus[0].id);
					src = that.state.topMenus[0].attributes.src;
					node = that.state.topMenus[0];
					this.state.selectedKeys = [];
					this.state.selectedKeys.push(node.id);
					this.state.defaultOpenKeys.push(node);
					this.findUrlFromNodes(this.state.topMenus,node.path);
					if(this.props.mode)
					{
						this.sendEvent("selectTopMenuItem",that.state.topMenus[0]);
					}
					
				}
				let menuItem = that.state.topMenus[0];
				if(window.clientMap.useTopMenu)
				{
					if(menuItem.children&&menuItem.children.length>1){
						$("#jz-left-body").show(); 
						$("#feasApp").removeClass("openTopMenuFullPage"); 
					}
					else
					{
						$("#jz-left-body").hide();
						$("#feasApp").addClass("openTopMenuFullPage");
					}
					
				}
				
				 
				
				
				
			}
			else
			{
				console.log("无菜单权限！")
			}
			 
			
		}
		
		
		
		
	}

    //alert("相应hash值：" + hash)

    // this.currentUrl = src;
	if(src||(node&&node.id))
	{
		if(src==='null')
		{			 
			this.$emit("HashChange",this.getQueryVariable("sp"),JSON.parse(JSON.stringify(node)));
		}
		else
		{	
			 
			if(node)
			{
				this.$emit("HashChange",src,JSON.parse(JSON.stringify( node)));
			}
			
		}
		
		
	} 
	this.refresh();

  }
  
  

  onSelect = (obj) => {
    //alert(JSON.stringify(obj.key));
	
	console.log("选中菜单:"+obj.key);
	
	if(this.props.mode)
	{
		//水平模式
		let targetMenuItem = this.getMenuItem(this.state.menus, obj.key);
		if (targetMenuItem) {
			 
		 
		  
		  // 然后选择第一个菜单节点？？
		  if(targetMenuItem.children&&targetMenuItem.children.length>0)
		  { 
			
			if(window.topCurrentMenuPage&&window.topCurrentMenuPage[targetMenuItem.id])
			{
				for(let i=0;i<targetMenuItem.children.length;i++)
				{
					if(targetMenuItem.children[i].id==window.topCurrentMenuPage[targetMenuItem.id].id)
					{
						this.openHashSp(targetMenuItem.children[i].path);
						this.state.selectedKeys = [];
						this.state.selectedKeys.push(targetMenuItem.id);
						break;
					}
				}
			}
			else
			{
				this.openHashSp(targetMenuItem.children[0].path);
				this.state.selectedKeys = [];
				this.state.selectedKeys.push(targetMenuItem.id);
			}
			  
		  	 
			
			// this.onHashChange();
		  }
		  else
		  {
			  this.openHashSp(targetMenuItem.path);
			  this.state.selectedKeys = [];
			  this.state.selectedKeys.push(targetMenuItem.id);
			   this.refresh();
			   let  src = targetMenuItem.attributes.src;
			   this.$emit("HashChange",src,JSON.parse(JSON.stringify(targetMenuItem)));
		  }
		  
		  
		  
		  
		   this.sendEvent("selectTopMenuItem",targetMenuItem);
		   
		 
		  
		  
		  /*
		  this.openHashSp(targetMenuItem.path);
		  this.state.selectedKeys = [];
		  this.state.selectedKeys.push(targetMenuItem.id);
		  this.onHashChange();
		  */
		}
		this.refresh();
		
	}
	else
	{
		let targetMenuItem = this.getMenuItem(this.state.menus, obj.key);
		if (targetMenuItem) {
		  
		  this.openHashSp(targetMenuItem.path);
		  this.state.selectedKeys = [];
		  this.state.selectedKeys.push(targetMenuItem.id);
		  this.onHashChange();
		}
		this.refresh();
	}
	
   
  }

  getMenuItem = (menus, key) => {
    for (let i = 0; i < menus.length; i++) {
      if (menus[i].id === key) {
        return menus[i];
      }
      if (menus[i].children && menus[i].children.length > 0) {
        let target = this.getMenuItem(menus[i].children, key);

        if (target) {
          return target;
        }
      }
    }
    return null;
  }

  openHashSp = (sp,pdata) => {

    // 参数处理

    let params = "";
    let url = window.location.href;

    let urls = url.split("?");

    let existsSp = false;
 

    if (!existsSp) {
        params = "sp=" + sp;
    }
	
	let newPdata = {};
	
	if(!this.getUrlParameter("fromSp"))
	{
		params +="&fromSp="+this.getUrlParameter("sp");
	}
	
	
	
	if(pdata&& typeof pdata!='string'&&typeof pdata=='object')
	{
		for(let p in pdata)
		{
			if(p=="id")
			{
				params +="&"+p+"="+pdata[p];
			}
			
			 
			if(typeof pdata[p] != "function")
			{
				//delete pdata[p]; 
				newPdata[p]= pdata[p];
			}
		}
	}



    window.history.pushState({ sp: sp,pdata:newPdata }, "", "?" + params);

    // 触发一次变更，fs-view 修改了当前url，通过值的绑定来更新
    //this.onHashChange();

  }

  renderMenus = (menus) => {

    return menus.map((item, index) => {
      if (item.children && item.children.length > 0&&!this.props.mode) {
        return <SubMenu key={item.id}    icon={<span className={item.icon} style={{ fontSize: '18px', marginRight: '16px', marginLeft: '1px',  marginTop:'0px' }} />} title={item.text}>
          {this.renderMenus(item.children)}
        </SubMenu>
      }
      else {
        return <Menu.Item key={item.id} icon={<span className={item.icon} style={{ fontSize: '18px', marginRight: '16px', marginLeft: '1px', marginTop:'0px' }} />}>
          {item.text}
        </Menu.Item>
      }
    });
  }

  render() {
    // defaultSelectedKeys={['1']}
    // defaultOpenKeys={['sub1']}
	
	// horizontal
	
	// theme = "dark"  light  Theme
	
    return (

<div>
{
	this.state.menus&&this.state.menus.length>0&&this.props.mode&& <Menu
        mode={this.props.mode?this.props.mode:'inline'}
        theme={this.props.theme}
        
        onClick={this.onSelect}
		selectedKeys={this.state.selectedKeys}
		defaultOpenKeys={this.state.defaultOpenKeys}
      > 
        {
          this.renderMenus(this.state.menus)
        }  
      </Menu>
}
{
	this.state.menus&&this.state.menus.length>0&&!this.props.mode&& <Menu
        mode={this.props.mode?this.props.mode:'inline'}
        theme={this.props.theme}
        inlineCollapsed={this.props.isCollapse}
        onClick={this.onSelect}
		selectedKeys={this.state.selectedKeys}
		defaultOpenKeys={this.state.defaultOpenKeys}
      > 
        {
          this.renderMenus(this.state.menus)
        }  
      </Menu>
}

     </div>


    );
  }
}

